import { UnifiedNav } from "../../shared/layout/unified-nav";

export function PublicNav() {
  return <UnifiedNav />;
}
